import React from "react";
import PropTypes from "prop-types";
import styles from "./StudentCard.module.scss";
import ProfilePicture from "../../../../components/profilePicture/ProfilePicture";

const StudentCard = ({ student }) => (
  <div className={styles.studentCard}>
    <div className={styles.studentCardHeader}>
      <ProfilePicture
        firstName={student.firstName}
        lastName={student.lastName}
        profilePicture={student.profilePicture}
      />
      <span className={styles.studentName}>
        {`${student.firstName} ${student.lastName}`}
      </span>
    </div>
    <table className={styles.studentDetails}>
      <tbody>
        <tr>
          <th>Clinical Site</th>
          <td>{student.clinicalSite?.name || '-'}</td>
        </tr>
        <tr>
          <th>Year</th>
          <td>{student.program?.currentYear?.year || '-'}</td>
        </tr>
        <tr>
          <th>Specialty</th>
          <td>{student.speciality?.name || '-'}</td>
        </tr>
        <tr>
          <th>Status</th>
          <td>
            {student.status && (
              <span className={`${styles.statusTag} ${styles[student.status?.toLowerCase()]}`}>
                {student.status}
              </span>
            )}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
);

StudentCard.propTypes = {
  student: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profilePicture: PropTypes.string,
    clinicalSite: PropTypes.shape({ name: PropTypes.string }),
    program: PropTypes.shape({
      currentYear: PropTypes.shape({ year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) }),
    }),
    speciality: PropTypes.shape({ name: PropTypes.string }),
    status: PropTypes.string,
  }).isRequired,
};

export default StudentCard;
